import type { AdminUserDetailDto, AdminUserListItemDto, UserRole } from '@familychef/shared';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchAdminUserDetail, fetchAdminUsers, updateAdminUserRole } from '../lib/admin-api';

export type UserRow = AdminUserListItemDto;

export function useUsers(search: string) {
  return useQuery({
    queryKey: ['users', search],
    queryFn: () => fetchAdminUsers(search),
  });
}

export type UserDetail = AdminUserDetailDto;

export function useUserDetail(id: string) {
  return useQuery<UserDetail>({
    queryKey: ['user', id],
    queryFn: () => fetchAdminUserDetail(id),
    enabled: !!id,
  });
}

export function useUpdateUserRole(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (role: UserRole) => updateAdminUserRole(id, role),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['user', id] });
      void qc.invalidateQueries({ queryKey: ['users'] });
    },
  });
}
